import { Component, OnInit, Output, EventEmitter, Input } from "@angular/core";
import { Observable } from "rxjs";
import { FileUploader, FileItem, FileLikeObject } from "ng2-file-upload";
import { FileUploaderService } from "src/app/shared/services/file-uploader.service";
@Component({
  selector: "app-upload-imagem",
  templateUrl: "./upload-imagem.component.html",
  styleUrls: ["./upload-imagem.component.scss"],
})
export class UploadImagemComponent implements OnInit {
  imgUploader$: Observable<FileUploader>;
  hasBaseDropImageUpload = false;
  imgUploadMessage: string;
  imgUploadError = false;

  @Output()
  beforeUpload: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  completeUpload: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  remove: EventEmitter<any> = new EventEmitter<any>();

  @Input()
  url?: string;

  @Input()
  urlUpload?: string;

  @Input()
  name?: string;

  @Input()
  allowedMimeType?: string[] = ["image/png", "image/jpg", "image/jpeg", "image/webp"];

  @Input()
  helpText?: string;

  @Input()
  layout?: string;

  @Input()
  maxSizeText? = "Tamanho máximo: 4MB";

  @Input()
  maxSizeBytes = 4 * 1024 * 1024; //4MB

  @Input()
  labelText? = "Arraste e solte a imagem aqui";

  @Input()
  filename?;

  flagIsUploading = false;

  errorUpload = false;

  flagErrorMimeType = false;

  @Input()
  buttonLabel? = "SELECIONAR ARQUIVO";

  @Input()
  additionalParameter?: Record<string, unknown>;

  uploader;

  constructor(private fileUploaderService: FileUploaderService) {}

  ngOnInit() {
    this.initImageFileUploader();
  }

  testMimeType(mime) {
    this.flagErrorMimeType = true;
    this.allowedMimeType.forEach((type) => {
      if (mime === type) {
        this.flagErrorMimeType = false;
      }
    });
    return this.flagErrorMimeType;
  }

  getUploader() {
    return this.uploader;
  }

  updateUploader(url?) {
    if (url) {
      this.urlUpload = url;
    }
    this.initImageFileUploader();
  }

  private async initImageFileUploader() {
    this.imgUploader$ = this.fileUploaderService.getInstance(
      {
        onBeforeUploadItem: (item: FileItem) => {
          this.flagErrorMimeType = false;
          this.imgUploadMessage = `Enviando arquivo ${item.file.name}`;
          this.name = item.file.name;
          this.imgUploadError = false;
          this.flagIsUploading = true;
          this.beforeUpload.emit(item);
          this.testMimeType(item.file.type);
        },
        onCompleteItem: (fileItem: FileItem, response: any) => {
          this.flagIsUploading = false;
          if (response.success) {
            this.url = response.url;
            this.imgUploadMessage = undefined;
          } else {
            this.errorUpload = true;
            this.imgUploadError = true;
            this.imgUploadMessage = response.status;
          }
          this.completeUpload.emit({
            fileItem,
            response,
            nameFile: response.fileName
              ? response.fileName
              : fileItem.file.name,
            success: response.success,
          });
        },
      },
      {
        url: this.urlUpload,
        allowedMimeType: this.allowedMimeType,
        maxFileSize: this.maxSizeBytes,
        additionalParameter: this.additionalParameter,
      }
    );
    this.imgUploader$.subscribe((uploader) => {
      this.uploader = uploader;
    });
  }
  
  removeLogo(): void {
    this.remove.emit(this.url);
    this.url = undefined;
  }

  fileOverBase(e: any) {
    this.hasBaseDropImageUpload = e;
  }
}
